// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "./Box.res.js";
import * as Stack from "./Stack.res.js";
import * as Title from "../typography/Title.res.js";
import * as React from "react";
import * as Inline from "./Inline.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as GoBackButton from "../navigation/GoBackButton.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  container: {
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "minHeight-kAzted": "minHeight-x2lwn1j",
    "overflow-kVQacm": "overflow-xysyzu8",
    "paddingInline-kg3NbH": "paddingInline-xj7an9n",
    "paddingTop-kLKAdn": "paddingTop-x1cnzs8",
    "position-kVAEAm": "position-x1n2onr6",
    $$css: "wino-gc:src/resources/layout-and-structure/Page.res.js:15"
  }
};
function containerStyleFromParams(variation) {
  if (variation === "compact") {
    return {
      paddingBottom: "20px"
    };
  } else {
    return {
      paddingBottom: "90px"
    };
  }
}
function Page(props) {
  let renderHeaderActions = props.renderHeaderActions;
  let renderActions = props.renderActions;
  let __renderTitleEnd = props.renderTitleEnd;
  let subtitle = props.subtitle;
  let title = props.title;
  let __variation = props.variation;
  let variation = __variation !== undefined ? __variation : "standard";
  let renderTitleEnd = __renderTitleEnd !== undefined ? __renderTitleEnd : () => null;
  let match = Navigation.useGoBack();
  let newrecord = {
    ...Stylex.props(styles.container, containerStyleFromParams(variation))
  };
  let tmp;
  if (title !== undefined) {
    let newrecord$1 = {
      ...{
        className: "alignItems-x6s0dn4 display-x78zum5",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/Page.res.js:25"
      }
    };
    let newrecord$2 = {
      ...{
        className: "display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf",
        "data-style-src": "wino-gc:src/resources/layout-and-structure/Page.res.js:29"
      }
    };
    newrecord$1.children = [JsxRuntime.jsx("div", (newrecord$2.children = JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Inline.make, {
          children: [JsxRuntime.jsx(Title.make, {
            children: title,
            level: 2
          }), renderTitleEnd()],
          space: "medium",
          alignY: "bottom",
          wrap: true
        }), subtitle !== undefined ? JsxRuntime.jsx(TextStyle.make, {
          children: subtitle,
          variation: "normal",
          size: "small"
        }) : null],
        space: "xsmall"
      }),
      space: "medium"
    }), newrecord$2)), renderActions !== undefined ? renderActions() : null];
    tmp = JsxRuntime.jsxs("div", newrecord$1);
  } else {
    tmp = null;
  }
  let newrecord$3 = {
    ...{
      className: "display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/Page.res.js:34"
    }
  };
  newrecord.children = [variation === "standard" && match[0] ? JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(GoBackButton.make, {}),
    spaceBottom: subtitle !== undefined ? "medium" : "small"
  }) : null, tmp, renderHeaderActions !== undefined ? JsxRuntime.jsx(Box.make, {
    children: renderHeaderActions(),
    spaceTop: "medium"
  }) : null, JsxRuntime.jsx("div", (newrecord$3.children = props.children, newrecord$3))];
  return JsxRuntime.jsxs("div", newrecord);
}
let make = React.memo(Page);
export { make };
/* styles Not a pure module */